import { Box, Heading, Text, VStack } from '@chakra-ui/react'
import type { AttendeePrintDto } from '../../../types/lobbyDay'
import { PrintPacketCard } from './PrintPacketCard'

export function AttendeePrintSection({ attendee }: { attendee: AttendeePrintDto }) {
  return (
    <Box className="attendee-print-section" mb={8}>
      <Heading size="md">{attendee.fullName}</Heading>
      <Text color="muted">{attendee.districtLabel ?? 'No district data'} · {attendee.deliveryMode}</Text>
      {attendee.meetings.length === 0
        ? <Text mt={3} fontStyle="italic">No meetings scheduled yet.</Text>
        : <VStack align="stretch" mt={3}>{attendee.meetings.map((m) => <PrintPacketCard key={m.meetingId} packet={m} />)}</VStack>}
    </Box>
  )
}
